'use client'

import React, { useState } from 'react'
import styles from './styles.module.css'
import useSaleClock from '../../../SaleCampaign/useSaleClock'
import { getCampaignPhase, PHASE_LIVE, PHASE_TEASER } from '../../../../lib/saleCampaign'

// "How the sale works" cards + the guarantee + an FAQ, all from the section doc
// (`cards[] {title,text,icon}`, `guaranteeTitle/guaranteeText`, `faqs[] {q,a}`).
// Pure presentation; hidden outside the campaign window like the other sale
// sections so the page never shows stale dates.
function SaleInfo({ saleCampaign: campaign, saleNowMs, saleClockOffsetMs, title, cards, guaranteeTitle, guaranteeText, faqTitle, faqs }) {
  const { nowMs } = useSaleClock(saleNowMs, saleClockOffsetMs, 60000)
  const [open, setOpen] = useState(0)
  const phase = getCampaignPhase(campaign, nowMs)
  if (phase !== PHASE_LIVE && phase !== PHASE_TEASER) return null

  return (
    <section className={styles.wrap}>
      <div className={styles.inner}>
        {Array.isArray(cards) && cards.length > 0 && (
          <>
            {title && <h2 className={styles.title}>{title}</h2>}
            <div className={styles.cards}>
              {cards.map((c) => (
                <div key={c._key || c.title} className={styles.card}>
                  {c.icon && <span className={styles.icon} aria-hidden="true">{c.icon}</span>}
                  <h3 className={styles.cardTitle}>{c.title}</h3>
                  <p className={styles.cardText}>{c.text}</p>
                </div>
              ))}
            </div>
          </>
        )}

        {guaranteeTitle && (
          <div className={styles.guarantee}>
            <h2 className={styles.guaranteeTitle}>{guaranteeTitle}</h2>
            {guaranteeText && <p className={styles.guaranteeText}>{guaranteeText}</p>}
          </div>
        )}

        {Array.isArray(faqs) && faqs.length > 0 && (
          <div className={styles.faq}>
            <h2 className={styles.faqTitle}>{faqTitle || 'FAQ'}</h2>
            <ul className={styles.faqList}>
              {faqs.map((f, i) => {
                const isOpen = open === i
                return (
                  <li key={f._key || f.q} className={styles.faqItem}>
                    <button
                      type="button"
                      className={styles.faqQ}
                      aria-expanded={isOpen}
                      onClick={() => setOpen(isOpen ? -1 : i)}
                    >
                      <span>{f.q}</span>
                      <span className={styles.faqSign} aria-hidden="true">{isOpen ? '−' : '+'}</span>
                    </button>
                    <div className={styles.faqA} hidden={!isOpen}>{f.a}</div>
                  </li>
                )
              })}
            </ul>
          </div>
        )}
      </div>
    </section>
  )
}

export default SaleInfo
